// @ts-check
// Aviso das novidades em cartão (contrato 08-contrato-novidades.md, seção 7): no celular, acima da barra flutuante e
// sumindo junto com ela; no desktop com o menu recolhido, no canto ao lado do trilho. Mais curto que o balão: o título,
// a frase de resumo da versão e os mesmos dois botões. Esconder pela rolagem não marca a versão como vista.
import { html } from 'htm/preact';
import { useId } from 'preact/hooks';
import { Link } from '../../app/router.js';
import { Button } from '../../ui/button.js';
import { Icon } from '../../ui/icon.js';
import { markReleaseNotesSeen } from '../../data/release-notes.js';
import { releaseNoteAnchorId, releaseNoteTextKey } from '../../../../shared/release-notes/release-notes.js';
import { useReleaseNotesSurface } from './release-notes-state.js';
import { t } from '../../i18n/index.js';

export function ReleaseNotesCard() {
  const { announcement, isMobile, isCardMounted, isCardHidden } = useReleaseNotesSurface();
  const titleId = `release-notes-card-title-${useId()}`;
  if (!announcement || !isCardMounted) return null;
  const tabIndex = isCardHidden ? -1 : undefined;
  return html`<section
    class="release-notes-card"
    role="region"
    aria-labelledby=${titleId}
    aria-hidden=${isCardHidden ? 'true' : undefined}
    data-hidden=${isCardHidden ? 'true' : undefined}
    data-layout=${isMobile ? 'mobile' : 'rail'}
    data-testid="release-notes-card"
    onKeyDown=${(/** @type {KeyboardEvent} */ event) => {
      if (event.key === 'Escape') markReleaseNotesSeen();
    }}
  >
    <div class="release-notes-surface-header">
      <span class="release-notes-surface-icon" aria-hidden="true"><${Icon} name="IconSparkles" size=${16} /></span>
      <h2 class="release-notes-surface-title" id=${titleId}>${t('releaseNotes.balloon.title', { version: announcement.version })}</h2>
    </div>
    <p class="release-notes-card-summary">${t(`releaseNotes.versions.${releaseNoteTextKey(announcement.version)}.summary`)}</p>
    <div class="release-notes-surface-actions">
      <${Link}
        href=${`/release-notes#${releaseNoteAnchorId(announcement.version)}`}
        className="button release-notes-see-all"
        data-variant="secondary"
        data-accent="default"
        data-size="small"
        tabindex=${tabIndex}
        onClick=${() => markReleaseNotesSeen()}
      ><span class="button-title">${t('releaseNotes.balloon.seeAll')}</span><//>
      <${Button} title=${t('releaseNotes.balloon.dismiss')} accent="blue" size="small" tabindex=${tabIndex} onClick=${() => markReleaseNotesSeen()} />
    </div>
  </section>`;
}
